import { Paper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { GeneralContainer, useStyles } from "./MyCasesContainer.styled";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import MyCasesListComponent from "../../components/MyCasesListComponent/MyCasesListComponent";
import { useLazyQuery } from "@apollo/client";
import {
  CASES_BY_MANAGER_PROFILE_AFTER,
  CASES_BY_MANAGER_PROFILE_BEFORE,
  CASES_BY_MANAGER_PROFILE_FIRST,
  CASE_STATUSES,
} from "../../GraphQL/Queries";
import { clientPolicyIngsight } from "../../App";
import { useHistory } from "react-router-dom";
import { AntTab, AntTabs } from "../../helpers/antTabs";

const MyCasesContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const rSearch = useRef();
  const rStatus = useRef();
  const [allPages, setAllPages] = useState(null);
  const [value, setValue] = useState(0);
  const [selectedMenu, selectMenu] = useState(["cases", "My Cases"]);
  const [renderAgain, setRenderAgain] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [statusValue, setStatusValue] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [activeHightPriority, setActiveHightPriority] = useState(false);
  const [searchTxt, setSearchTxt] = useState("");
  const [myCasesList, setMyCasesList] = useState([]);
  const [myListStatuses, setMyListStatuses] = useState([]);
  const [showCards, setShowCards] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10, 20]);
  const [page, setPage] = useState(0);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const rDateValue = useRef();

  const [runQueryCasesByManagerProfileFirst, { loading: loadingFirstCases }] =
    useLazyQuery(CASES_BY_MANAGER_PROFILE_FIRST, {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.casesByManagerProfile) {
          asignData(data);
          setShowLoader(false);
        }
      },
    });

  const [runQueryCasesByManagerProfileAfter, { loading: loadingAfterCases }] =
    useLazyQuery(CASES_BY_MANAGER_PROFILE_AFTER, {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.casesByManagerProfile) {
          asignData(data);
          setShowLoader(false);
        }
      },
    });

  const [runQueryCasesByManagerProfileBefore, { loading: loadingBeforeCases }] =
    useLazyQuery(CASES_BY_MANAGER_PROFILE_BEFORE, {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.casesByManagerProfile) {
          asignData(data);
          setShowLoader(false);
        }
      },
    });

  const [runQueryListOfStatuses] = useLazyQuery(CASE_STATUSES, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.caseStatuses) {
        let list = data.caseStatuses.map((item, index) => {
          return {
            value: item.idCaseStatus,
            label: item.statusName,
          };
        });
        setMyListStatuses([...list]);
      }
    },
  });

  const handleChange = (event, newValue) => {
    if (newValue === 0) selectMenu(["cases", "My Cases"]);
    setValue(newValue);
    setRenderAgain(!renderAgain);
  };

  const handleChangeStatus = (event) => {
    setStatusValue(event?.value);
  };

  const handleChangeDate = (event) => {
    if (event.currentTarget.value !== "") {
      setDateValue(new Date(event.currentTarget.value).toJSON());
    }
  };

  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const asignData = (data) => {
    setAllPages(data.casesByManagerProfile.totalCount);
    if (data.casesByManagerProfile.pageInfo.hasNextPage === true) {
      setEndCursor(data.casesByManagerProfile.pageInfo.endCursor);
    }
    if (data.casesByManagerProfile.pageInfo.hasPreviousPage === true) {
      setStartCursor(data.casesByManagerProfile.pageInfo.startCursor);
    }
    const casesByManagerProfile = data.casesByManagerProfile.nodes.map(
      (cm) => ({ ...cm })
    );
    if (casesByManagerProfile) {
      setMyCasesList(casesByManagerProfile);
    }
  };

  const handleChangePage = (item, newPage) => {
    if (newPage > page) {
      setShowLoader(true);
      runQueryCasesByManagerProfileAfter({
        variables: {
          searchBy: searchTxt,
          caseStatusId: statusValue,
          date: dateValue,
          hightPriority: activeHightPriority ? activeHightPriority : null,
          first: rowsPerPage,
          after: endCursor,
        },
      });
    }
    if (newPage < page) {
      setShowLoader(true);
      runQueryCasesByManagerProfileBefore({
        variables: {
          searchBy: searchTxt,
          caseStatusId: statusValue,
          date: dateValue,
          hightPriority: activeHightPriority ? activeHightPriority : null,
          first: rowsPerPage,
          before: startCursor,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (item) => {
    setRowsPerPage(item.target.value ? parseInt(item.target.value) : 5);
    setPage(0);
    runQueryCasesByManagerProfileFirst({
      variables: {
        searchBy: searchTxt,
        caseStatusId: statusValue,
        date: dateValue,
        hightPriority: activeHightPriority ? activeHightPriority : null,
        first: item.target.value ? parseInt(item.target.value) : 5,
      },
    });
  };

  const handleSeeDetails = (rowData) => {
    history.push({ pathname: "/MyCaseDetail", state: { detail: rowData } });
  };

  const resetFilters = () => {
    rStatus.current?.clearValue();
    rDateValue.current.value = "";
    setStatusValue(null);
    setDateValue(null);
    setSearchTxt("");
  };

  useEffect(() => {
    runQueryListOfStatuses();
    runQueryCasesByManagerProfileFirst({
      variables: {
        searchBy: searchTxt,
        caseStatusId: statusValue,
        date: dateValue,
        hightPriority: activeHightPriority ? activeHightPriority : null,
        first: rowsPerPage,
      },
    });
  }, [renderAgain]);

  useEffect(() => {
    if (
      searchTxt ||
      statusValue ||
      dateValue ||
      activeHightPriority ||
      activeHightPriority === false
    ) {
      setPage(0);
      runQueryCasesByManagerProfileFirst({
        variables: {
          searchBy: searchTxt,
          caseStatusId: statusValue,
          date: dateValue,
          hightPriority: activeHightPriority ? activeHightPriority : null,
          first: rowsPerPage,
        },
      });
    }
  }, [searchTxt, statusValue, dateValue, activeHightPriority]);

  const showSelectedMenu = () => {
    if (selectedMenu[0] === "cases") {
      return (
        <MyCasesListComponent
          statusValue={statusValue}
          handleChangeStatus={handleChangeStatus}
          dateValue={dateValue}
          handleChangeDate={handleChangeDate}
          activeHightPriority={activeHightPriority}
          setActiveHightPriority={setActiveHightPriority}
          handleSearch={handleSearch}
          ref={{ rSearch, rStatus, rDateValue }}
          showCards={showCards}
          setShowCards={setShowCards}
          myCasesList={myCasesList}
          page={page}
          allPages={allPages}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePage}
          handleSeeDetails={handleSeeDetails}
          myListStatuses={myListStatuses}
          rDateValue={rDateValue}
          resetFilters={resetFilters}
          loadingFirstCases={loadingFirstCases}
          loadingAfterCases={loadingAfterCases}
          loadingBeforeCases={loadingBeforeCases}
        />
      );
    }
  };

  return (
    <GeneralContainer>
      <Paper square style={{ marginBottom: "17px" }}>
        <AntTabs className={classes.tabs} value={value} onChange={handleChange}>
          <AntTab label="My Cases" valueTabs={value} />
        </AntTabs>
      </Paper>
      {showSelectedMenu()}
      {showLoader && <ModalLoader />}
    </GeneralContainer>
  );
};

export default MyCasesContainer;
